<template>
  <div>
    <a-input-number
      v-show="editable"
      ref="input"
      :min="0"
      v-model="value"
      @pressEnter="check"
      @blur="check"
      @focus="onFocus"
      style="width: 100%"
    />
    <a-tooltip :title="value" v-show="!editable">{{ value || 0 }}</a-tooltip>
  </div>
</template>
<script>
export default {
  name: 'ColumnNumberEditor',
  text: {
    type: [Number],
    default: undefined
  },
  data() {
    return {
      value: this.text,
      editable: false
    }
  },
  methods: {
    check() {
      if (this.value===undefined||this.value===null){
        this.value=0
      }
      this.editable = false
      this.$emit('change', this.value)
    },
    edit() {
      this.editable = true
      this.$nextTick(() => {
        this.$refs.input.focus()
      })
    },
    onFocus(e) {
      e.target.select()
    }
  }
}
</script>
